// extracted by mini-css-extract-plugin
export default {"container":"IdColumn_container__9qB93"};